import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';

const PropertyTaxInformation = () => {
    return (
        <Container className='pt-4'>
            <h4 className="fw-semibold mb-3">Property Taxes and Assessment</h4>


            <Table bordered responsive className="mb-0" style={{ borderRadius: '6px', overflow: 'hidden' }}>
                <tbody>
                    <tr>
                        <td className="bg-light text-muted w-50">Year</td>
                        <td>2022</td>
                    </tr>
                    <tr>
                        <td className="bg-light text-muted">Tax</td>
                        <td>$8,083</td>
                    </tr>
                    <tr>
                        <td className="bg-light text-muted">Assessment</td>
                        <td>$427,210</td>
                    </tr>
                </tbody>
            </Table>


            <small className="text-muted">Home facts updated by county records</small>
        </Container>
    );
};

export default PropertyTaxInformation;